import DepositExportsPage from './DepositExportsPage';

export default DepositExportsPage;
